"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var View_1 = require("../View");
var types_1 = require("./types");
var helpers_1 = require("../helpers");
exports.boxBackground = function (_a) {
    var selected = _a.selected, hovered = _a.hovered, willSelect = _a.willSelect, disabled = _a.disabled, theme = _a.theme;
    var internalWillSelect = willSelect || hovered;
    if (disabled) {
        return "background-color: " + theme.colorBackgroundNeutralLight + ";";
    }
    if (internalWillSelect && selected) {
        return "background-color: " + theme.colorSelectedCellOverlay + ";";
    }
    if (internalWillSelect && !selected) {
        return "background-color: " + theme.colorNotSelectedCellOverlay + ";";
    }
    if (selected) {
        return "background-color: " + theme.colorHighlightDark + ";";
    }
    return "background-color: " + theme.colorNotSelectedCell + ";";
};
exports.calcTileWidth = function (size) {
    if (size === void 0) { size = types_1.SCHEDULING_MATRIX_TILE_SIZE.m; }
    switch (size) {
        case types_1.SCHEDULING_MATRIX_TILE_SIZE.xxl:
            return helpers_1.SIZE_XXL;
        case types_1.SCHEDULING_MATRIX_TILE_SIZE.xl:
            return helpers_1.SIZE_XL;
        default:
            return helpers_1.SIZE_M;
    }
};
var Box = styled_components_1.default(View_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n\n    ", "\n"], ["\n    width: ", ";\n    height: ", ";\n\n    ", "\n"])), function (_a) {
    var size = _a.size;
    return exports.calcTileWidth(size);
}, helpers_1.SIZE_L, exports.boxBackground);
exports.Tile = function (_a) {
    var _b = _a.selected, selected = _b === void 0 ? false : _b, disabled = _a.disabled, _c = _a.willSelect, willSelect = _c === void 0 ? false : _c, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, _d = _a.size, size = _d === void 0 ? types_1.SCHEDULING_MATRIX_TILE_SIZE.m : _d;
    var _e = react_1.useState(false), active = _e[0], setActive = _e[1];
    var _f = react_1.useState(false), hovered = _f[0], setHovered = _f[1];
    var onMouseEnterHandler = react_1.useCallback(function (event) {
        setHovered(true);
        setActive(false);
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(event);
    }, []);
    var onMouseLeaveHandler = react_1.useCallback(function (event) {
        setHovered(false);
        setActive(false);
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(event);
    }, []);
    var onClickHandler = function () {
        setActive(true);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (react_1.default.createElement(Box, { collapsable: false, size: size, selected: selected, willSelect: !active && willSelect, hovered: !active && hovered, disabled: disabled, onClick: onClickHandler, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler, onMouseDown: onMouseDown, onMouseUp: onMouseUp }));
};
exports.Tile.sizes = types_1.SCHEDULING_MATRIX_TILE_SIZE;
var templateObject_1;
//# sourceMappingURL=Tile.js.map